import { useEffect, useState } from "react";
import { adminApi, apiError } from "@/admin/api";
import { toast } from "sonner";
import { Plus, Trash2, X } from "lucide-react";

const ROLES = ["content_manager", "donation_manager", "super_admin"];

export default function AdminUsers() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(null);

  const load = () => adminApi.get("/admin/users").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    try { await adminApi.post("/admin/users", form); toast.success("Admin created"); setForm(null); load(); }
    catch (err) { toast.error(apiError(err)); }
  };
  const del = async (id) => { if (!window.confirm("Deactivate this admin?")) return; await adminApi.delete(`/admin/users/${id}`); toast.success("Deactivated"); load(); };

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-bold text-gray-900">Admin Users</h1>
        <button data-testid="new-admin" onClick={() => setForm({ email: "", name: "", role: "content_manager", password: "" })} className="inline-flex items-center gap-2 rounded-lg bg-[hsl(13_65%_54%)] text-white px-4 py-2 text-sm font-medium"><Plus size={15} /> New Admin</button>
      </div>
      <div className="bg-white rounded-xl border border-gray-200 overflow-x-auto">
        <table className="w-full text-sm" data-testid="admins-table">
          <thead className="bg-gray-50 text-left text-xs uppercase tracking-wider text-gray-500"><tr><th className="p-3">Name</th><th className="p-3">Email</th><th className="p-3">Role</th><th className="p-3">Status</th><th className="p-3"></th></tr></thead>
          <tbody>
            {rows.map((u) => (
              <tr key={u.id} className="border-t border-gray-100">
                <td className="p-3 font-medium text-gray-800">{u.name}</td>
                <td className="p-3">{u.email}</td>
                <td className="p-3 capitalize">{u.role.replace("_", " ")}</td>
                <td className="p-3">{u.active ? <span className="text-emerald-600">Active</span> : <span className="text-gray-400">Inactive</span>}</td>
                <td className="p-3 text-right">{u.role !== "super_admin" && <button onClick={() => del(u.id)} className="text-red-600"><Trash2 size={15} /></button>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {form && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={() => setForm(null)}>
          <form onSubmit={create} onClick={(e) => e.stopPropagation()} data-testid="admin-form" className="bg-white rounded-2xl p-6 w-full max-w-sm space-y-3">
            <div className="flex items-center justify-between"><h2 className="font-semibold">New Admin</h2><button type="button" onClick={() => setForm(null)}><X size={18} /></button></div>
            <input data-testid="af-name" placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full py-2 px-3 rounded-lg border border-gray-300 text-sm" />
            <input data-testid="af-email" type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full py-2 px-3 rounded-lg border border-gray-300 text-sm" />
            <select data-testid="af-role" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} className="w-full py-2 px-3 rounded-lg border border-gray-300 text-sm">
              {ROLES.map((r) => <option key={r} value={r}>{r.replace("_", " ")}</option>)}
            </select>
            <input data-testid="af-pw" type="password" placeholder="Temp password (8+, letter & number)" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full py-2 px-3 rounded-lg border border-gray-300 text-sm" />
            <button data-testid="af-submit" className="w-full rounded-lg bg-[hsl(13_65%_54%)] text-white py-2.5 text-sm font-semibold">Create</button>
          </form>
        </div>
      )}
    </div>
  );
}
